import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { subMilliseconds } from "date-fns";
import DataStore from "./../../../stores/DataStore";
import { observer } from "mobx-react";
import { when } from "mobx";
// import AttributeModul from '../AttributeModul';

/**
 * @class
 * Zur Anzeige einer Gruppe an Slidern
 * Mit ein paar Vordefinierten Möglichkeiten zur Angabe von Rules
 * @name SliderGroupAttribute
 * @implements {Attribute}
 */
class SliderGroupAttribute extends Component {
  constructor(params) {
    super(params);
  }

  onChange(event, newValue) {
    const { attribute: { onChange, value = "" } = {}, messageHandler } =
      this.props;

    onChange(newValue);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    return this.slider
      .map((atr) => DataStore.attributeValues[atr.id].modul.getValueString())
      .join();
  }

  getInfosFromServer() {
    const requestConfig = {
      url: this.sliderUrl,
    };
    DataStore.dataHandler.getInfosFromServer(
      requestConfig,
      (data) => this.setInfosFromServer(data),
      () => { }
    );
  }

  setInfosFromServer(data) {
    //schauen wie das wird...
  }

  getSummaryDisplay() {
    return (
      <div
        style={{
          borderStyle: "solid",
          borderWidth: "1px",
          borderRadius: "5px",
          borderColor: "lightgrey",
          minHeight: "50px",
          display: "flex",
          flexDirection: "column",
          padding: "5px",
          width: "100%",
        }}
      >
        {this.slider.map((atr) =>
          DataStore.attributeValues[atr.id].modul.getSummaryDisplay()
        )}
      </div>
    );
  }

  getConfig() {
    const {
      attribute: {
        id = "",
        name = "",
        description = "",
        tooltip = "",
        type = "",
        rules = [],
        requestKey,
        attributeOption: {
          slider = [],
          akkumMin,
          akkumMax,
          akkumExact, // Daraus Rules?
          steps,
        },
        onChange,
        placeholder,
        required,
        virtuell,
        value,
        min,
        max,
        attributeModul,
        controlState: { require = false, readOnly = false },
      } = {},
      messageHandler,
    } = this.props;
    this.id = id;
    this.requestKey = requestKey;
    if (requestKey) {
      this.slider = DataStore.requestStore.requests[requestKey].value;
    } else {
      this.slider = slider;
    }
    if (steps) {
      this.slider.forEach((s) => {
        s.steps = steps;
      });
    }
    if (readOnly) {
      this.slider.forEach((s) => {
        s.readOnly = readOnly;
      });
    }
    this.slider.forEach((s) => {
      s.type = "slider";
    });
    rules.push({
      condition: {
        atom: {
          customMultiAttributeFunction: (values) => this.ruleFunction(values),
          multiAttributes: this.slider.map((s) => s.id),
        },
      },
      ifViolatedType: "error",
      ifViolatedText: this.getErrorText(),
    });
    if (requestKey !== undefined) {
      this.slider.forEach((s, i) => {
        if (
          DataStore.attributeValues[this.id + "sub"].valueChanged !== undefined
        ) {
          s.value = DataStore.attributeValues[this.id + "sub"].valueChanged[i];
        }
        DataStore.addAttribute(s, i);
        // if (
        //   DataStore.attributeValues[s].value !==
        //   DataStore.attributeValues[this.id].value
        // ) {
        //   DataStore.attributeValues[s].setValue(
        //     DataStore.attributeValues[this.id].value
        //   );
        // }
      });
    }
    const conf = {
      id: `${id}sub`,
      name,
      rules,
      description,
      placeholder,
      tooltip,
      type: "attributeCollection",
      readOnly,
      required,
      attributeOption: { attributes: this.slider },
      virtuell,
    };
    return conf;
  }

  getSliders() {
    const {
      attribute: {
        attributeOption: { slider = [], akkumMin, akkumMax, akkumExact }, // Daraus Rules?
      },
    } = this.props;
  }

  getErrorText() {
    const {
      attribute: {
        attributeOption: { akkumMin, akkumMax, akkumExact },
      },
    } = this.props;
    if (akkumExact) {
      return `Die Summe muss genau ${akkumExact} ergeben`;
    }
    if (akkumMin && !akkumMax) {
      return `Die Summe muss mindestens ${akkumMin} ergeben`;
    }
    if (!akkumMin && akkumMax) {
      return `Die Summe darf höchstens ${akkumMax} ergeben`;
    }
    if (akkumMin && akkumMax) {
      return `Die Summe muss zwischen  ${akkumMin} und ${akkumMax} liegen`;
    }
    return "";
  }

  ruleFunction(values) {
    const {
      attribute: {
        attributeOption: { akkumMin, akkumMax, akkumExact },
      },
    } = this.props;
    const sum = values.reduce(function (pv, cv) {
      return pv + cv;
    }, 0);
    if (akkumExact) {
      return sum === akkumExact;
    }
    let minMaxWert = true;
    if (akkumMin) {
      minMaxWert = minMaxWert && sum >= akkumMin;
    }
    if (akkumMax) {
      minMaxWert = minMaxWert && sum <= akkumMax;
    }
    return minMaxWert;
  }

  render() {
    const { attribute: { attributeModul } = {}, AtrModClass } = this.props;
    attributeModul.holdedAttribute = this;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.messageHandler.logDebugFormatted(
      "SliderGroup",
      "render",
      "",
      this.props,
      this.state
    );
    return <AtrModClass attribute={this.getConfig()} />;
  }
}

export default observer(SliderGroupAttribute);
